import { render, staticRenderFns } from "./StatsReports.container.vue?vue&type=template&id=71322a1b&scoped=true&"
import script from "./StatsReports.container.vue?vue&type=script&lang=js&"
export * from "./StatsReports.container.vue?vue&type=script&lang=js&"
import style0 from "./StatsReports.container.vue?vue&type=style&index=0&id=71322a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71322a1b",
  null
  
)

export default component.exports